<template>
  <!-- <div id="workbench"></div> -->
  <div id="review-report">
    <div class="ipub-h1 line-h-40  mar-b-20">
      Check Decision
    </div>
    <div class="content-bg"
         style="padding-bottom:20px">
      <div class="mar-b-10 ">
        <div class="ipub-h3 ipub-title-tab line-h-40 mar-b-10">Manuscript Information</div>
        <div class="ipub-title-tab-part">
          <div class="mar-b-12 ipub-p2 ">
            <span class="fw-bd ipub-block__span">Manuscript No.</span>
            <span class="">{{journalResponse.code}}</span>
          </div>
          <div class="mar-b-12 ipub-p2">
            <span class="fw-bd ipub-block__span">Article Type</span>
            <span class="ipub-block__font">{{journalResponse.detail && manuscriptType[journalResponse.detail.typeCode]}}</span>
          </div>
          <div class="mar-b-12 ipub-p2">
            <span class="fw-bd ipub-block__span">Article Title</span>
            <span class="ipub-block__font">{{journalResponse.detail && journalResponse.detail.title}}</span>
          </div>
          <div class="flex ipub-p2"
               v-if="journalResponse.fileList && journalResponse.fileList.length">
            <span class="fw-bd ipub-block__span">Attachment(s)</span>
            <div class="ipub-block__font">
              <ipub-label class="ipub-c-p mar-b-10 ipub-p2"
                          type="link"
                          style="margin-right:8px"
                          v-for="(item,index) in journalResponse.fileList"
                          :key="item.id">
                <ipub-radio :checked="item.authorShowed"
                            @change="reviewAuthor(item)"
                            checkBox
                            label="" />
                {{item.name}}
                <ipub-icon type="iconDownload1"
                           @click="download(item,index)"
                           class="mar-l-10" />
              </ipub-label>
            </div>
          </div>
        </div>
      </div>

      <div class="mar-b-10 ipub-title-tab-part">
        <ipub-row style="margin-bottom:6px">
          <div style="margin-right:20px"
               class="mar-b-10">
            <span class="ipub-p2 fw-bd">Decision</span>
            <font class="key-color">*</font>
          </div>
          <ipub-radio-group v-model="reviews.meditorDecision"
                            v-if="!isView">
            <ipub-radio @change="changeStatus"
                        v-for="(value, key) in termList"
                        :key="key"
                        :value="key">
              <div style="margin-right:22px"
                   class="ipub-p2">{{ value }}</div>
            </ipub-radio>
          </ipub-radio-group>
        </ipub-row>
        <ipub-row>
          <ipub-col :span="6"
                    class="flex"
                    style="align-items: center;"
                    v-show="['PENDING_MINOR_REVISIONS','PENDING_MAJOR_REVISIONS','ACCEPT_MINOR','AFTER_MAJOR'].includes(reviews.meditorDecision)">
            <span class="ipub-p2 fw-bd"
                  style="width:140px;margin-right:16px">Revision Due Date</span>
            <ipub-date-picker prop="reviseDueTime"
                              @change="changeDate"
                              style="width:260px"
                              placeholder="Revision Due Date"
                              v-model="reviews.reviseDueTime">

            </ipub-date-picker>
          </ipub-col>
        </ipub-row>
        <div class=" mar-b-20"
             v-if="['REJECTED','REJECTED_OR_REST'].includes(reviews.meditorDecision)">
          <div class="ipub-p2 fw-bd mar-b-10">Reject Reason(Visible Only in Editorial Office)<font class="key-color">*</font>
          </div>
          <div>
            <div class="wrapper">
              <ul class="item_wrapper">
                <li class="item_first mar-b-10"
                    v-for="(item,index) in refuseList"
                    :key="item.id">
                  <div @click="checkItem(index)"
                       class="item">
                    <input type="radio"
                           name="root"
                           class="radio-select"
                           :checked="item.checked">
                    <label :for="'ipub-radio-group'+(item.id||item.name||index)"></label>
                    {{item.name}}
                  </div>
                  <ul class="item_second mar-l-20 "
                      style="margin-top:10px;"
                      v-show="isOpenItem[index] && isOpenItem[index].group">
                    <li v-for="(node,i) in item.children"
                        class="mar-b-10"
                        :key="'leaf'+i">
                      <input @click="stateChanged(node,index,i)"
                             type="radio"
                             :id="'ipub-radio-group'+(node.id||node.name||i)"
                             class="radio-select"
                             name="leaf"
                             :checked="node.checked">
                      <label :for="'ipub-radio-group'+(node.id||node.name||i)"></label>
                      <label class="content-wrap">
                        {{node.name}}
                      </label>
                      <ipub-textarea class=" mar-l-20"
                                     placeholder="Please enter the other reject reason in details"
                                     style="margin-top:10px;width: 650px;display: block;"
                                     v-show="node.check"
                                     v-model="othersReason" />
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <div class="ipub-h3 line-h-40 mar-b-10 ipub-title-tab"
             @click="()=>{showAcademic = !showAcademic}">
          Academic Editor’s Report
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',showAcademic?'':'rotate-180']"
                     type="iconArrow" />
        </div>
        <ipub-form v-show="!showAcademic"
                   class="ipub-title-tab-part"
                   ref="reviews-commit"
                   :model="reviews"
                   :rules="rules">
          <div>
            <div class="mar-b-12">
              <span class="ipub-p2 fw-bd">Decision</span>
              <span class="ipub-p2 fw-bd mar-l-20">{{reviews.macademicDecision && termList[reviews.macademicDecision.decisionStatus]}}
              </span>
            </div>
          </div>
          <div class="mar-b-10">
            <ipub-form-item prop="editorNotes"
                            label="">
              <div class="ipub-p2 fw-bd mar-b-6"
                   slot="label">
                Comments to Editor
              </div>
              <ipub-textarea placeholder="Comments to Editor"
                             v-model.trim="reviews.macademicDecision.editorNotes"
                             :disabled="isView"
                             :autoSize="{ cols: '', rows: '6' }" />

            </ipub-form-item>
          </div>
          <div class="mar-b-10">
            <ipub-form-item prop="authorNotes"
                            label="">
              <div class="ipub-p2 fw-bd mar-b-6"
                   slot="label">
                Comments to Author
                <font class="key-color"
                      v-if="!['ACCEPT_CURRENT','PEER_REVIEW'].includes(reviews.meditorDecision)">*</font>
              </div>
              <ipub-textarea placeholder="Comments to Author"
                             v-model.trim="reviews.macademicDecision.authorNotes"
                             :disabled="isView"
                             :autoSize="{ cols: '', rows: '6' }" />

            </ipub-form-item>
          </div>

          <div class="ipub-p2 fw-bd fw-bd flex line-h-20 relative mar-b-10">
            <div>Attachment(s)</div>
            <div class="mar-l-20"
                 v-if="!isView">
              <ipub-upload v-if="!loadingAtt"
                           @change="handleUpload"
                           class="ipub-c-p link-color"
                           multiple>
                <ipub-icon type="iconAdd" /> Add New Attachment(s)
              </ipub-upload>
              <font class="line-color"
                    v-else>
                <ipub-icon :type="loading?'loading':'iconAdd'" /> Add New Attachment(s)
              </font>
            </div>
            <span v-if="reviews.macademicDecision && reviews.macademicDecision.macademicFileList">
              <span class="ipub-cursor-pointer border-view  mar-l-12 ipub-p4 act-font-color"
                    style="padding:5px 6px;background:#fff"
                    :key="'reviewerFileList'+index"
                    v-for="(item,index) in reviews.macademicDecision.macademicFileList"
                    v-show="isView"
                    @click="download(item,index)">{{item.name}}</span>
            </span>
          </div>

          <div class="file-contain mar-b-20"
               v-show="!isView">
            <div class="flex"
                 v-if="reviewerFileList && reviewerFileList.length>0">
              <ipub-label class="mar-b-10 flex"
                          style="margin-right:8px"
                          type="link"
                          :key="'reviewerFileList'+index"
                          v-for="(item,index) in reviewerFileList">
                <ipub-radio :checked="item.authorShowed"
                            @change="reviewAuthor(item)"
                            checkBox
                            label="" />
                <div class="ipub-p2 fw-bd"
                     style="cursor:pointer"
                     @click="download(item,index)">{{item.name}}
                  <ipub-icon type="iconDownload1"
                             class="mar-l-10" />
                </div>
                <ipub-icon class="ipub-p2 mar-l-20 ipub-cursor-pointer"
                           @click="del(index)"
                           type="iconDelete" />
              </ipub-label>
            </div>
          </div>

          <div v-if="type==='PRE_CHECK' && reviewsResponse.suggestReviewerList && reviewsResponse.suggestReviewerList.length>0"
               class="mar-b-20">
            <div class="ipub-p2 fw-bd fw-bd line-h-40 relative mar-b-20">Suggest Reviewers
              <span style="margin-left:20px;color:#536576"
                    v-for="(item,index) in reviewsResponse.suggestReviewerList"
                    :key="'item'+index">{{item.firstName }} {{item.lastName}}({{item.email}})</span>
            </div>
            <ipub-row :gutter="20"
                      v-show="!isView"
                      v-for="(item,index) in reviews.reviewerList"
                      :key="'item'+index">
              <ipub-col :span="3">
                <ipub-form-item prop="firstName"
                                label="First Name">
                  <ipub-input v-model.trim="item.firstName"
                              placeholder="First Name" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="3">
                <ipub-form-item prop="lastName"
                                label="Last Name">
                  <ipub-input v-model.trim="item.lastName"
                              placeholder="Last Name" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="5">
                <ipub-form-item prop="email"
                                label="Email">
                  <ipub-input v-model.trim="item.email"
                              placeholder="Email" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="1">
                <div class="flex"
                     style="align-items: center;justify-content: center;width: 100%;height: 100%;">
                  <ipub-button type="primary"
                               plain
                               @click="delReviewer(index)">delete</ipub-button>
                </div>

              </ipub-col>
            </ipub-row>
          </div>
          <div class="mar-b-20"
               v-if="!isView">
            <ipub-button type="primary"
                         plain
                         :style="{ minWidth: '150px' }"
                         v-if="type!=='PRE_CHECK'"
                         @click="$router.back(-1)">Cancel</ipub-button>
            <ipub-button type="primary"
                         :style="{ minWidth: '150px' }"
                         @click="commit()">Confirm</ipub-button>
          </div>
        </ipub-form>
      </div>

      <!-- Pre-Check History  academicHistoryList -->
      <div class="mar-b-20">
        <div class="ipub-h3 line-h-40 mar-b-12 ipub-title-tab"
             @click="()=>{showVersion = !showVersion}"
             v-show="reviewsResponse.macademicHistoryList && reviewsResponse.macademicHistoryList.length>0">
          <span v-if="type ==='PRE_CHECK'">Pre-check History</span>
          <span v-if="type ==='FIRST_CHECK'">First Decisions History</span>
          <span v-if="type ==='FINAL_CHECK'">Final Decisions History</span>
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',showVersion?'':'rotate-180']"
                     type="iconArrow" />
        </div>
        <div v-show="!showVersion && reviewsResponse.macademicHistoryList && reviewsResponse.macademicHistoryList.length>0"
             class="ipub-title-tab-part mar-b-12"
             v-for="(item,index) in reviewsResponse.macademicHistoryList"
             :key="'editorHistory'+index">
          <div class="ipub-p2 mar-b-4">
            <span class="ipub-h3 link-color fw-bd">Professor {{item.person.firstName}} {{item.person.lastName}} </span>({{item.person.email}})
          </div>
          <div class="ipub-p2">
            <div class="flex mar-b-10">
              <div class="ipub-block__span">Invited Date</div>
              <div class="ipub-block__font">{{item.invitedTime ? $moment(item.invitedTime).format('DD / MM / YYYY') : '--'}}</div>
            </div>
            <div class="flex mar-b-10">
              <div class="ipub-block__span">Decision Date</div>
              <div class="ipub-block__font">{{item.completedTime ? $moment(item.completedTime).format('DD / MM / YYYY') : '--'}}</div>
            </div>
            <div class="flex mar-b-10">
              <div class="ipub-block__span">Decision</div>
              <div class="ipub-block__font success-color ipub-cursor-pointer"
                   @click="showDecision(item)">{{termListStatus[item.decisionStatus]}}</div>
            </div>
            <div class="flex mar-b-10">
              <div class="ipub-block__span">Comments to Editor</div>
              <div class="ipub-block__font">
                <div class="font-color flex"
                     v-if="item.editorNotes && item.editorNotes.length>500">
                  <div v-if="!item.isMoreText"
                       v-html="item.editorNotes.substr(0,500).replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')+'...'"></div>
                  <div v-if="item.isMoreText"
                       v-html="item.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                  <a class="link-color"
                     @click="togalReport(item,'isMoreText')">
                    {{item.isMoreText?'Hidden':'View More'}}
                  </a>
                </div>
                <div :class="[item.editorNotes?'font-color':'line-color']"
                     v-else
                     v-html="item.editorNotes ? item.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ') : 'No notes or comments.'"></div>
              </div>
            </div>
            <div class="flex mar-b-10">
              <div class="ipub-block__span">Comments to Author</div>
              <div class="ipub-block__font">
                <div class="flex font-color"
                     v-if="item.authorNotes && item.authorNotes.length>500">
                  <div v-if="!item.isMoreText1"
                       v-html="item.authorNotes.substr(0,500).replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')+'...'"></div>
                  <div v-if="item.isMoreText1"
                       v-html="item.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                  <a class="link-color"
                     @click="togalReport(item,'isMoreText1')">
                    {{item.isMoreText1?'Hidden':'View More'}}
                  </a>
                </div>
                <div :class="[item.authorNotes?'font-color':'line-color']"
                     v-html="item.authorNotes ? item.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ') : 'No notes or comments.'"
                     v-else></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Reviewer reviewsResponse -->
      <div class="mar-b-20"
           v-if="reviewsResponse.editorReviewerList && reviewsResponse.editorReviewerList.length>0  && type !='PRE_CHECK'">
        <div class="ipub-h3 line-h-40 mar-b-12 ipub-title-tab"
             @click="()=>{showReviewer = !showReviewer}">
          Reviewers
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',showReviewer?'':'rotate-180']"
                     type="iconArrow" />
        </div>
        <div v-show="!showReviewer"
             class="ipub-title-tab-part">
          <li class="review-item flex-center mar-b-12"
              v-for="(item,index) in reviewsResponse.editorReviewerList"
              :key="index+item.personId">
            <p class="ipub-p2 fw-bd"
               style="width:8%">Reviewer {{item.seq}}</p>
            <p class="ipub-p2 fw-bd"
               style="width:18%;">{{item.firstName}} {{item.lastName}}</p>

            <p class="ipub-p2 fw-bd"
               style="width:34%">{{termListStatus[item.reviewerDecisionList[0].decisionStatus] }} (Report sent on {{$moment(item.reviewerDecisionList[0].completedTime).format('MMMM Do YYYY')}})
              <span v-if="item.reviewerDecisionList.length>1">(includes<a class="act-font-color"
                   :href="'#toReport'+index"> author’s reply</a>)</span>
            </p>
            <p class="ipub-p2 fw-bd"
               style="width:40%">Last decision: {{item.reviewerDecisionList[0].lastSign ? termListStatus[item.reviewerDecisionList[0].lastSign.decisionStatus] : null}}</p>
          </li>
        </div>
      </div>
      <!-- Reviewer -->
      <div v-for="(item,index) in reviewsResponse.editorReviewerList"
           :key="'reviewer'+index"
           v-show="reviewsResponse.editorReviewerList && reviewsResponse.editorReviewerList.length>0 && type !='PRE_CHECK'">
        <div class="mar-b-20">
          <div class="ipub-h3 fw-bd line-h-40  mar-b-12 ipub-title-tab"
               @click="togalReviewer(item)">
            Reviewer {{item.seq}}: {{title[item.titleCode]}} {{item.firstName}} {{item.lastName}}
            <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',item.showReviewer?'':'rotate-180']"
                       type="iconArrow" />
          </div>
          <div class="ipub-p2 ipub-title-tab-part"
               v-if="!item.showReviewer">
            <div class="mar-b-12 flex-center">
              <span class="fw-bd ipub-block__span">Email</span>
              <span class="ipub-block__font">{{item.email}}</span>
            </div>

            <div class="mar-b-12 flex-center"
                 v-if="item.countryCode">
              <span class="fw-bd ipub-block__span">Country</span>
              <span class="ipub-block__font">{{country[item.countryCode]}}</span>
            </div>

            <div class="mar-b-12 flex-center">
              <span class="fw-bd ipub-block__span">Affiliation</span>
              <span class="ipub-block__font">{{item.affiliation}}</span>
            </div>

            <div class="mar-b-12 flex-center">
              <span class="fw-bd ipub-block__span">Reserach Keywords</span>
              <span class="ipub-block__font">{{item.keyword?item.keyword:'--'}}</span>
            </div>
          </div>
        </div>
        <div class="mar-b-20"
             v-for="(itemrep,indexrep) in item.reviewerDecisionList"
             :key="itemrep.id">
          <div :class="['ipub-p2','fw-bd','mar-b-20','font-color','ipub-title-report','line-h-40']"
               @click="togalReport(itemrep,'showReport')">
            Report {{item.reviewerDecisionList.length-indexrep}} ({{termListStatus[itemrep.decisionStatus]}})
            <span>{{itemrep.completedTime ? $moment(itemrep.completedTime).format('HH:mm DD / MM / YYYY'): ''}}</span>
            <ipub-icon :class="['mar-l-40 rotate ipub-cursor-pointer',itemrep.showReport?'':'rotate-180']"
                       type="iconArrow" />
          </div>
          <div v-if="!itemrep.showReport">
            <div class="ipub-title-tab-part">
              <div class="mar-b-20">
                <div class="ipub-p2  mar-b-12">
                  <span class="fw-bd">Review the Revised Manuscript</span><span class=" mar-l-20">{{itemrep.revised?'Yes':'No'}}</span>
                </div>
                <div class="ipub-p2 fw-bd mar-b-12">
                  Custom Review Questions
                </div>
                <div class="question-answer">
                  <customerReviewQuestion :questionList="itemrep.questionList"></customerReviewQuestion>
                </div>
              </div>
              <div class="mar-b-20">
                <div class="ipub-p2 fw-bd fw-bd mar-b-5">
                  Comments to Editor
                  <ipub-icon :class="['ipub-p5 mar-l-10 rotate ipub-cursor-pointer',itemrep.showEditor?'':'rotate-180']"
                             @click="togalEditor(itemrep,'showEditor')"
                             type="iconArrow" />
                </div>
                <ipub-textarea placeholder="Comments to Editor"
                               v-if="!itemrep.showEditor && indexrep === 0"
                               v-model="itemrep.editorNotes"
                               :autoSize="{ cols: '', rows: '6' }"
                               :disabled="indexrep === 0 ? false : true" />
                <div :class="['ipub-p2',itemrep.editorNotes ? '':'line-color']"
                     v-if="!itemrep.showEditor && indexrep != 0"
                     v-html="itemrep.editorNotes?itemrep.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' '):'No notes or comments.'"></div>
              </div>
              <div class="mar-b-20">
                <div class="ipub-p2 fw-bd fw-bd mar-b-5">
                  Comments to Author
                  <ipub-icon :class="['ipub-p5 mar-l-10 rotate ipub-cursor-pointer',itemrep.showAuthor?'':'rotate-180']"
                             @click="togalEditor(itemrep,'showAuthor')"
                             type="iconArrow" />
                </div>
                <ipub-textarea placeholder="Comments to Author"
                               v-model="itemrep.authorNotes"
                               v-if="!itemrep.showAuthor  && indexrep === 0"
                               :autoSize="{ cols: '', rows: '6' }"
                               :disabled="indexrep === 0 ? false : true" />
                <div :class="['ipub-p2',itemrep.authorNotes ? '':'line-color']"
                     v-if="!itemrep.showAuthor && indexrep != 0"
                     v-html="itemrep.authorNotes?itemrep.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' '):'No notes or comments.'"></div>
              </div>

              <div class="mar-b-20">
                <div class="ipub-p2 fw-bd flex fw-bd line-h-20 relative mar-b-20"
                     v-show="(itemrep.reviewerFileList && itemrep.reviewerFileList.length>0) || indexrep===0">
                  <div>Attachment(s)</div>
                  <div v-if="!isView || indexrep===0">
                    <div class="mar-l-20">
                      <ipub-upload v-if="!loading['reviewerFileList']"
                                   @change="e=>{handleUpload1(e,itemrep,index,'reviewerFileList')}"
                                   multiple
                                   class="link-color ipub-c-p">
                        <ipub-icon type="iconAdd" /> Add New Attachment(s)
                      </ipub-upload>
                      <font class="line-color"
                            v-else>
                        <ipub-icon :type="loading['reviewerFileList']?'loading':'iconAdd'" /> Add New Attachment(s)
                      </font>
                    </div>
                  </div>
                </div>
                <div class="file-contain">
                  <ipub-label class="mar-b-10 flex ipub-p2"
                              type="link"
                              style="margin-right:8px"
                              :key="'reviewerfile'+indexfile"
                              v-for="(itemfile,indexfile) in itemrep.reviewerFileList">
                    <ipub-radio :checked="itemfile.authorShowed"
                                @change="reviewAuthor(itemfile)"
                                :disabled="indexrep != 0"
                                v-show="indexrep === 0"
                                checkBox
                                label="" />
                    <div class="ipub-p2 ipub-cursor-pointer"
                         @click="download(itemfile,indexfile)">{{itemfile.name}}
                      <ipub-icon type="iconDownload1"
                                 class="mar-l-10" />
                    </div>
                    <ipub-icon class="ipub-p2 mar-l-10 ipub-cursor-pointer border-left"
                               @click="del1(itemrep,indexfile,'reviewerFileList')"
                               v-if="itemfile.reviewerSelf"
                               type="iconDelete" />
                  </ipub-label>
                </div>
              </div>
            </div>

            <div v-if="indexrep!=0">
              <a :name="'toReport'+index">
                <div class="ipub-p2 fw-bd mar-b-12 font-color line-h-40 ipub-title-report"
                     @click="togalEditor(itemrep,'showAuthorReplay')">
                  Author’s Response to Report {{item.reviewerDecisionList.length-indexrep}}
                  <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',itemrep.showAuthorReplay?'':'rotate-180']"
                             type="iconArrow" />
                </div>
                <div v-if="!itemrep.showAuthorReplay"
                     class="ipub-title-tab-part">
                  <div class="mar-b-20">
                    <div class="ipub-p2 fw-bd fw-bd mar-b-12">
                      Author’s Note
                    </div>
                    <ipub-textarea placeholder="Author’s Note"
                                   v-if="journalResponse.sign-1===itemrep.sign"
                                   v-model="itemrep.authorReply"
                                   :autoSize="{ cols: '', rows: '5' }" />
                    <div class="ipub-p2"
                         v-else
                         v-html="itemrep.authorReply?itemrep.authorReply.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' '):'- -'"></div>
                  </div>
                  <div v-show="itemrep.authorReplyFileList && itemrep.authorReplyFileList.length>0">
                    <div class="ipub-p2 fw-bd mar-b-10 flex">
                      Author’s Response File
                      <div v-if="journalResponse.sign-1===itemrep.sign">
                        <div class="mar-l-20">
                          <ipub-upload v-if="!loading['authorReplyFileList']"
                                       @change="e=>{handleUpload1(e,itemrep,index,'authorReplyFileList')}"
                                       multiple
                                       class="link-color ipub-c-p">
                            <ipub-icon type="iconAdd" /> Add New Review Document
                          </ipub-upload>
                          <font class="line-color"
                                v-else>
                            <ipub-icon :type="loading['authorReplyFileList']?'loading':'iconAdd'" /> Add New Review Document
                          </font>
                        </div>
                      </div>
                    </div>
                    <div>
                      <ipub-label style="margin-right:10px;cursor:pointer"
                                  class="ipub-p2"
                                  type="link"
                                  :key="itemauth.id"
                                  hover
                                  v-for="(itemauth,indexauth) in itemrep.authorReplyFileList">{{itemauth.name}}
                        <ipub-icon type="iconDownload1"
                                   @click="download(itemauth,indexauth)"
                                   class="mar-l-10" />
                        <ipub-icon class="ipub-p2 mar-l-10 ipub-cursor-pointer border-left"
                                   @click="del1(itemrep,indexauth,'authorReplyFileList')"
                                   type="iconDelete" />
                      </ipub-label>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <SendEmail :isVisable="showSendEmail"
               :inputData="inputData"
               :files="files"
               :event="event"
               @send="send"
               @cancel="showSendEmail = false" />
  </div>
</template>



<script>
import main from './main.js'
export default main

</script>

<style lang="scss" scoped>
@import './main.scss';
.act-font-color {
  color: $link_color;
}
.border-view {
  border: 1px $link_color solid;
  border-radius: 4px;
  color: $link_color;
}
</style>
